<template>
    <div class="bodyContent-form">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="title wow fadeInUp">Not Verified</h1>
                </div>
            </div>

            <div class="container text-center py-5">
                <h2 class="textGreen wow fadeInUp">Verify your account</h2>
                <p> Hello, {{ user.first_name }}! Registration successful, please check your inbox
                    and click confirmation link. If you did not receive the email, click &nbsp;<a class="pointer"
                        @click="verifyResend"> here </a> &nbsp;to request another</p>
                <div class="mt-5">
                    <div class="alert alert-success" role="alert" v-if="success">
                        {{ success }}
                    </div>
                    <div class="alert alert-danger" role="alert" v-if="error">
                        {{ error }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
import { mapGetters, mapActions } from "vuex";
export default {
    name: "Verifiction",
    components: { 
        
    },
    data() {
        return {             
          success: null,
          error: null
        }
    },
    
  computed: {
    ...mapGetters("auth", ["user"])
  },

  methods: {
    ...mapActions("auth", ["sendVerifyResendRequest"]),

    verifyResend() {
      this.success = this.error = null;
      this.sendVerifyResendRequest()
        .then(() => {
          this.success =
            "A fresh verification link has been sent to your email address.";
        })
        .catch(error => {
          this.error = "Error sending verification link.";
        });
    }
  }
}

</script>

<style scoped>

</style>